var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"careers content-container content-container--narrow",class:{ 'careers--min-height-100vh' : _vm.isFilterOpen }},[_c('CareerSearch',{on:{"togglePageHeader":_vm.togglePageHeader}}),_c('CareerResults')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }